export const questionnaires = {
  en: {
    title: "Questionnaire Builder",
    subtitle: "Manage questions, stages, and service questionnaires",
    newQuestion: "New Question",
    newStage: "New Stage",
    questions: "Questions",
    stages: "Stages",
    preview: "Preview",
    questionsStatistics: "Questions statistics",
    stagesStatistics: "Stages statistics",
    totalQuestions: "Total Questions",
    active: "Active",
    byType: "By Type",
    categories: "Categories",
    totalStages: "Total Stages",
    serviceTypes: "Service Types",
    searchQuestions: "Search questions...",
    searchStages: "Search stages...",
    filterByType: "Filter by question type",
    filterByCategory: "Filter by category",
    filterByServiceType: "Filter by service type",
    allTypes: "All Types",
    allCategories: "All Categories",
    allServiceTypes: "All Service Types",
    code: "Code",
    labelEn: "Label (EN)",
    type: "Type",
    category: "Category",
    usedIn: "Used In",
    actions: "Actions",
    order: "Order",
    nameEn: "Name (EN)",
    questionsList: "Questionnaire questions list",
    stagesList: "Questionnaire stages list",
    loadingQuestions: "Loading questions...",
    loadingStages: "Loading stages...",
    noQuestionsFound: "No questions found.",
    noStagesFound: "No stages found.",
    edit: "Edit",
    duplicate: "Duplicate",
    delete: "Delete",
    editStage: "Edit Stage",
    questionnairePreview: "Questionnaire Preview",
    noStagesConfigured: "No stages configured for",
    serviceType: "service type.",
    questionsCount: "questions",
    estTime: "Est. time:",
    min: "min",
    editQuestion: "Edit Question",
    createQuestion: "Create a new question for the questionnaire.",
    updateQuestion: "Update the question details.",
    questionTextEn: "Question Text (EN)",
    questionTextEs: "Question Text (ES)",
    descriptionEn: "Description (EN)",
    descriptionEs: "Description (ES)",
    placeholderEn: "Placeholder (EN)",
    placeholderEs: "Placeholder (ES)",
    questionType: "Question Type",
    optionsOnePerLine: "Options (one per line)",
    translation: "Translation...",
    saveChanges: "Save Changes",
    editStageTitle: "Edit Stage",
    newStageTitle: "New Stage",
    updateStageDesc: "Update the stage details and questions.",
    createStageDesc: "Create a new stage for questionnaires.",
    nameEs: "Name (ES)",
    estMinutes: "Est. Minutes",
    iconOptional: "Icon (optional)",
    required: "Required",
    assignedQuestions: "Assigned questions",
    noQuestionsAssigned: "No questions assigned.",
    addQuestion: "Add question...",
    selectQuestionToAdd: "Select a question to add to this stage",
    req: "Req",
    deleteQuestion: "Delete Question",
    deleteStage: "Delete Stage",
    deleteQuestionConfirm: "Are you sure you want to delete",
    deleteStageConfirm: "Are you sure you want to delete stage",
    questionUsedInStages: "This question is used in",
    stagesCount: "stage(s).",
    removedFromAllStages: "It will be removed from all stages.",
    removeAllQuestionAssignments: "This will remove all question assignments for this stage.",
    createStage: "Create Stage",
    moveUp: "Move up",
    moveDown: "Move down",
    removeFromStage: "Remove from stage",
    markAsRequired: "Mark as required",
    codePlaceholder: "e.g., company_name",
    questionPlaceholder: "What is your company name?",
    optionalHelperText: "Optional helper text...",
    enterPlaceholderText: "Enter placeholder text...",
    optionPlaceholder: "Option 1\nOption 2\nOption 3",
    stageCodePlaceholder: "e.g., basic_info",
    stageNamePlaceholder: "Basic Information",
    stageDescPlaceholder: "Tell us about your company...",
    iconPlaceholder: "building",
  },
  es: {
    title: "Constructor de Cuestionarios",
    subtitle: "Gestiona preguntas, etapas y cuestionarios de servicio",
    newQuestion: "Nueva Pregunta",
    newStage: "Nueva Etapa",
    questions: "Preguntas",
    stages: "Etapas",
    preview: "Vista Previa",
    questionsStatistics: "Estadísticas de preguntas",
    stagesStatistics: "Estadísticas de etapas",
    totalQuestions: "Total Preguntas",
    active: "Activas",
    byType: "Por Tipo",
    categories: "Categorías",
    totalStages: "Total Etapas",
    serviceTypes: "Tipos de Servicio",
    searchQuestions: "Buscar preguntas...",
    searchStages: "Buscar etapas...",
    filterByType: "Filtrar por tipo de pregunta",
    filterByCategory: "Filtrar por categoría",
    filterByServiceType: "Filtrar por tipo de servicio",
    allTypes: "Todos los Tipos",
    allCategories: "Todas las Categorías",
    allServiceTypes: "Todos los Tipos de Servicio",
    code: "Código",
    labelEn: "Etiqueta (EN)",
    type: "Tipo",
    category: "Categoría",
    usedIn: "Usado En",
    actions: "Acciones",
    order: "Orden",
    nameEn: "Nombre (EN)",
    questionsList: "Lista de preguntas del cuestionario",
    stagesList: "Lista de etapas del cuestionario",
    loadingQuestions: "Cargando preguntas...",
    loadingStages: "Cargando etapas...",
    noQuestionsFound: "No se encontraron preguntas.",
    noStagesFound: "No se encontraron etapas.",
    edit: "Editar",
    duplicate: "Duplicar",
    delete: "Eliminar",
    editStage: "Editar Etapa",
    questionnairePreview: "Vista Previa del Cuestionario",
    noStagesConfigured: "No hay etapas configuradas para",
    serviceType: "tipo de servicio.",
    questionsCount: "preguntas",
    estTime: "Tiempo est.:",
    min: "min",
    editQuestion: "Editar Pregunta",
    createQuestion: "Crear una nueva pregunta para el cuestionario.",
    updateQuestion: "Actualizar los detalles de la pregunta.",
    questionTextEn: "Texto de Pregunta (EN)",
    questionTextEs: "Texto de Pregunta (ES)",
    descriptionEn: "Descripción (EN)",
    descriptionEs: "Descripción (ES)",
    placeholderEn: "Marcador de Posición (EN)",
    placeholderEs: "Marcador de Posición (ES)",
    questionType: "Tipo de Pregunta",
    optionsOnePerLine: "Opciones (una por línea)",
    translation: "Traducción...",
    saveChanges: "Guardar Cambios",
    editStageTitle: "Editar Etapa",
    newStageTitle: "Nueva Etapa",
    updateStageDesc: "Actualizar los detalles de la etapa y preguntas.",
    createStageDesc: "Crear una nueva etapa para cuestionarios.",
    nameEs: "Nombre (ES)",
    estMinutes: "Minutos Est.",
    iconOptional: "Icono (opcional)",
    required: "Requerido",
    assignedQuestions: "Preguntas asignadas",
    noQuestionsAssigned: "No hay preguntas asignadas.",
    addQuestion: "Agregar pregunta...",
    selectQuestionToAdd: "Seleccionar una pregunta para agregar a esta etapa",
    req: "Req",
    deleteQuestion: "Eliminar Pregunta",
    deleteStage: "Eliminar Etapa",
    deleteQuestionConfirm: "¿Estás seguro de que deseas eliminar",
    deleteStageConfirm: "¿Estás seguro de que deseas eliminar la etapa",
    questionUsedInStages: "Esta pregunta se usa en",
    stagesCount: "etapa(s).",
    removedFromAllStages: "Se eliminará de todas las etapas.",
    removeAllQuestionAssignments: "Esto eliminará todas las asignaciones de preguntas para esta etapa.",
    createStage: "Crear Etapa",
    moveUp: "Mover arriba",
    moveDown: "Mover abajo",
    removeFromStage: "Eliminar de la etapa",
    markAsRequired: "Marcar como requerido",
    codePlaceholder: "ej., nombre_empresa",
    questionPlaceholder: "¿Cuál es el nombre de tu empresa?",
    optionalHelperText: "Texto de ayuda opcional...",
    enterPlaceholderText: "Ingrese texto del marcador...",
    optionPlaceholder: "Opción 1\nOpción 2\nOpción 3",
    stageCodePlaceholder: "ej., info_basica",
    stageNamePlaceholder: "Información Básica",
    stageDescPlaceholder: "Cuéntanos sobre tu empresa...",
    iconPlaceholder: "building",
  },
};
